import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  fetchReservationUpcoming,
  unlinkReservation
} from '../../sagas/routines';
import {
  clearReservationUpcoming,
  reservationUpcomingOnChangePage,
  reservationUpcomingOnChangeOrder
} from '../../actions/upcoming';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'requestTime:asc'
};

const unlinkReservationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`all.${response.id}`, response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearReservationUpcomingHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const reservationUpcomingOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const reservationUpcomingOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchReservationUpcoming),
  ...unlinkReservationHandler(unlinkReservation),
  ...clearReservationUpcomingHandler(clearReservationUpcoming),
  ...reservationUpcomingOnChangePageHandler(reservationUpcomingOnChangePage),
  ...reservationUpcomingOnChangeOrderHandler(reservationUpcomingOnChangeOrder)
});
